module.exports = ".content {\n  min-height: 100vh; }\n\n.about {\n  padding-top: 70px;\n  padding-bottom: 50px; }\n\n.about h3 {\n    margin-bottom: 60px; }\n"